export default "__VITE_ASSET__Dj$Kt4HW__"